module.exports = __webpack_public_path__ + "static/media/23.15743c4a.png";